/*
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/api/poster.js
 * @Author: 张兴业
 * @Date: 2021-06-23 15:52:19
 * @LastEditors: 张兴业
 * @LastEditTime: 2021-07-13 17:05:14
 */

import request from "@/utils/request";

// 活动详情
export async function getActivitySubById(params) {
  const url = `/api/product/activitySub/getActivitySubById/${params.id}`;
  return request(url);
}

// 广告机-店主详情
export async function getStoreInfoInAdMachine(params) {
  const url = "/api/daemon/offlineStore/getStoreInfo";
  return request(url, { params });
}
